'use scrict';

/**
 * 指定した位置まで要素がスクロールした時に、classを追加する
 *
 * @param selector クラスを追加したい要素
 * @param className 追加したいクラス名
 */
export default function addClassWithScroll(selector, className) {
  $(selector).each(function() {

    // 画面左上から要素までの高さ - b
    var offset = $(this).offset().top;
    // 要素が画面に表示されるスクロール量(a - b)
    var scrollHeight = getScrollHeight(offset, getWindowHeight());

    // 画面の1/4を超えたら、classを追加
    if (getScrollTop() > scrollHeight + getWindowHeight() / 4) {
      $(this).addClass(className);
    }
  });
}

const getWindowHeight = () => {
  return window.document.documentElement.clientHeight;
}
const getScrollTop = () => {
  return document.documentElement.scrollTop || document.body.scrollTop;
}
const getScrollHeight = (offset, windowHeight) => {
  return offset - windowHeight;
}